import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { CSSTransition } from 'react-transition-group';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Ellipsis } from '@bibliocommons/deprecated-base-icons';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';
import { TextButton, GhostButton } from '@bibliocommons/deprecated-base-buttons';

import './BatchActionsToolbar.scss';

export default class BatchActionsToolbar extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (this.props.globalMessaging) {
      if (prevProps.selectedItems.size === 0 && this.props.selectedItems.size > 0) {
        this.props.messagingActions.clearGlobalMessage();
      } else {
        this.props.handleClear();
      }
    }
  }

  componentWillUnmount() {
    this.props.handleClear();
  }

  renderDropdown() {
    const { selectedItems, totalItems, renderActionsMenu, actionIsLoading } = this.props;
    const menuItems = renderActionsMenu ? renderActionsMenu(selectedItems.toList()) : null;
    if (!menuItems || menuItems.length === 0) {
      return null;
    }

    const renderDropdownButtonText = () => (
      <span>
        <span aria-hidden>
          <FormattedMessage id="batch_actions_edit_items" />
          <Ellipsis />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage
            id="ada_label_batch_actions_edit_items"
            values={{ totalItems, count: selectedItems.size }}
          />
        </ScreenReaderMessage>
      </span>
    );

    return (
      <Dropdown
        dropup
        right
        disableMobile
        dataKey="batch-actions-toolbar-dropdown"
        className="actions-dropdown"
        isLoading={actionIsLoading}
        ButtonTag={GhostButton}
        renderSelected={renderDropdownButtonText}
      >
        {menuItems}
      </Dropdown>
    );
  }

  renderSummary() {
    const { selectedItems, handleClear } = this.props;

    return (
      <div className="actions-summary">
        <span role="alert" aria-live="polite" aria-atomic="true">
          <FormattedMessage id="batch_actions_selected_count" values={{ count: selectedItems.size }} />
        </span>
        <TextButton className="clear-button" handleClick={handleClear}>
          <span aria-hidden>
            <FormattedMessage id="button_clear" />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="ada_label_batch_actions_clear" />
          </ScreenReaderMessage>
        </TextButton>
      </div>
    );
  }

  render() {
    const { renderAdditionalButtons } = this.props;

    return (
      <CSSTransition
        in={this.props.selectedItems.size > 0 && !this.props.globalMessaging}
        classNames="slide-up"
        timeout={{ enter: 250, exit: 100 }}
        mountOnEnter
        unmountOnExit
      >
        <div className="cp-batch-actions-toolbar">
          <div className="container toolbar-container">
            <div className="toolbar-content">
              {this.renderSummary()}
              <div className="toolbar-action-buttons">
                {renderAdditionalButtons ? renderAdditionalButtons(this.props.selectedItems.toList()) : null}
                {this.renderDropdown()}
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

BatchActionsToolbar.propTypes = {
  actionIsLoading: PropTypes.bool,
  totalItems: PropTypes.number.isRequired,
  selectedItems: ImmutablePropTypes.map.isRequired,
  handleClear: PropTypes.func.isRequired,
  renderActionsMenu: PropTypes.func,
  renderAdditionalButtons: PropTypes.func,
  globalMessaging: ImmutablePropTypes.map,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired
};

BatchActionsToolbar.defaultProps = {
  actionIsLoading: false
};
